
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/healthcheck",
      function () {
        return require("private-next-pages/healthcheck.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/healthcheck"])
      });
    }
  